import { render } from "./LeaderAssign.vue?vue&type=template&id=505a88b0"
import script from "./LeaderAssign.vue?vue&type=script&lang=js"
export * from "./LeaderAssign.vue?vue&type=script&lang=js"

import "./LeaderAssign.vue?vue&type=style&index=0&id=505a88b0&lang=css"

import exportComponent from "/var/www/html/youthmanna/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__